module.exports = __webpack_public_path__ + "img/talent.acaa0d0d.png";